if (!customElements.get('sr-cart-upsell')) {
  // Adds the recommended product without leaving the drawer, then re-renders the drawer
  // through Dawn's own cart-drawer element so totals and the header bubble stay in sync.
  class SrCartUpsell extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('form');
      this.button = this.querySelector('.sr-cart-upsell__button');
      this.spinner = this.querySelector('.sr-cart-upsell__spinner');
      this.error = this.querySelector('.sr-cart-upsell__error');
      if (this.form) this.form.addEventListener('submit', (e) => this.onSubmit(e));
    }

    async onSubmit(event) {
      const drawer = document.querySelector('cart-drawer');
      if (!drawer || typeof drawer.renderContents !== 'function') return; // fall back to a normal post
      event.preventDefault();
      if (this.button.getAttribute('aria-disabled') === 'true') return;

      this.button.setAttribute('aria-disabled', 'true');
      this.spinner.classList.remove('hidden');
      this.error.hidden = true;

      const data = new FormData(this.form);
      const sections = drawer.getSectionsToRender().map((s) => s.id);
      try {
        const res = await fetch(`${routes.cart_add_url}.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            items: [{ id: Number(data.get('id')), quantity: Number(data.get('quantity') || 1) }],
            sections,
            sections_url: window.location.pathname,
          }),
        });
        const json = await res.json();
        if (!res.ok || json.status) throw new Error(json.description || json.message || 'Error');
        drawer.classList.remove('is-empty');
        drawer.renderContents(json);
      } catch (err) {
        this.error.textContent = err.message;
        this.error.hidden = false;
        this.button.removeAttribute('aria-disabled');
        this.spinner.classList.add('hidden');
      }
    }
  }
  customElements.define('sr-cart-upsell', SrCartUpsell);
}
